import BillingCapabilitiesStore from "./BillingCapabilitiesStore";
import InvoicesStore from "./Invoices/InvoicesStore";
import RecurringStore from "./Recurring/RecurringStore";
import ReceivablesStore from "./Receivables/ReceivablesStore";

const billingStoreList = [
  // Mounted even on an unconfigured instance: the route gate reads it to decide
  // whether billing exists at all.
  { name: "billingCapabilitiesViewStore", store: BillingCapabilitiesStore },
  { name: "invoicesViewStore", store: InvoicesStore },
  { name: "recurringStore", store: RecurringStore },
  // Two instances of one class: Billing → Receivables (every client), and
  // Client 360's Billing tab (pinned to the open client by the ClientDetail route).
  { name: "receivablesViewStore", store: ReceivablesStore },
  { name: "clientReceivablesViewStore", store: ReceivablesStore },
];

export default billingStoreList;
